import { AxiosResponse } from "axios";
import { MerSETADtoIn } from "../../../Model/Dto/WSP/MerSETALAI";
import { BEECatergoryDto, MerSetaSDESearchRequest, TrainingSearchResult } from "../../../Model/Dto/WSP/MerSETASDE";
import { axiosWSPInstance } from "../../AxiosWSPInterceptor";
import * as ApiUrls from "./ApiUrl.merSETASDE";

export const MerSETASDEService = {
    GetMerSETACategoryInterventions: (): Promise<AxiosResponse<BEECatergoryDto[]>> => axiosWSPInstance.get(ApiUrls.CategoryInterventions),
    CreateMerSETASDE: (request: MerSETADtoIn): Promise<AxiosResponse<MerSETADtoIn>> => axiosWSPInstance.post(ApiUrls.merSETASDE, request),
    GetById: (merSetaSdeId: number): Promise<AxiosResponse<MerSETADtoIn>> => axiosWSPInstance.get(`${ApiUrls.merSETASDE}/${merSetaSdeId}`),
    UpdateMerSETASDE: (id: number, request: MerSETADtoIn): Promise<AxiosResponse<MerSETADtoIn>> => axiosWSPInstance.put(`${ApiUrls.merSETASDE}?id=${id}`, request),
    Delete: (merSetaSdeId: number): Promise<AxiosResponse<void>> => axiosWSPInstance.delete(`${ApiUrls.merSETASDE}/${merSetaSdeId}`),
    Search: (request: MerSetaSDESearchRequest): Promise<AxiosResponse<TrainingSearchResult>> => axiosWSPInstance.get(ApiUrls.Search, {
        params:
        {
            organisationId: request.organisationId,
            personId: request.personId,
            columnName: request.columnSortOption?.ColumnName,
            sortDirection: request.columnSortOption?.SortDirection,
            pageNumber: request.pageNumber,
            pageSize: request.pageSize,
            searchValue: request.searchValue,
            startDate: request.startDate?.toDateString(),
            endDate: request.endDate?.toDateString(),
            beeCategoryId: request.beeCategoryId,
            interventionTypeId: request.interventionTypeId,
            interventionTitleId: request.interventionTitleId
        }
    })
}